'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-13d783d6.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var UnstyledButton = styled__default['default'].button.withConfig({ displayName: "ww-uikit_UnstyledButton_kx7oenoo", componentId: "sc-17r1dfy" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    font: inherit;\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n    overflow: visible;\n    text-transform: none;\n    -webkit-appearance: button;\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    outline: inherit;\n"], ["\n    font: inherit;\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n    overflow: visible;\n    text-transform: none;\n    -webkit-appearance: button;\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    outline: inherit;\n"])));
var templateObject_1;

exports.default = UnstyledButton;
//# sourceMappingURL=index.js.map
